<template>
  <FlotoModule>
    <RouterView :key="$route.fullPath" />
  </FlotoModule>
</template>

<script>
import { LicenseComputed } from '@state/modules/license'
import { PreferenceComputed } from '@state/modules/preference'
import Constants from '@constants'
export default {
  name: 'ComputerModule',
  page() {
    return {
      title: this.$tc('computer'),
    }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (
        vm.availableModulesInLicense.indexOf(Constants.PATCH) === -1 &&
        vm.availableModulesInLicense.indexOf(Constants.DEPLOYMENT) === -1
      ) {
        return vm.$router.replace({ name: 'upgrade-plan' })
      }
      if (
        vm.myAllowedModules.indexOf(Constants.PATCH) === -1 &&
        vm.myAllowedModules.indexOf(Constants.DEPLOYMENT) === -1
      ) {
        return vm.$router.replace({ name: '404' })
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    // add any module level clean up logic here
    next()
  },
  computed: {
    ...LicenseComputed,
    ...PreferenceComputed,
  },
}
</script>
